export let GlobalSettingsKeys = /*#__PURE__*/function (GlobalSettingsKeys) {
  GlobalSettingsKeys["THEMES_KEY"] = "OpenUI.Theme.Default";
  GlobalSettingsKeys["USER_SUPPRESSED_MESSAGES"] = "HTML.USER_SUPPRESED_MESSAGES";
  GlobalSettingsKeys["FORMAT_LOCALE_KEY"] = "FormatLocale.DefaultLocale";
  GlobalSettingsKeys["OFFLINE_LOCALE_KEY"] = "OfflineLocale.DefaultLocale";
  GlobalSettingsKeys["PLAY_EARCONS"] = "HTML.Application.PlayEarcons";
  GlobalSettingsKeys["PLAY_VISUAL_EFFECTS"] = "HTML.Application.PlayVisualEffects";
  GlobalSettingsKeys["ENABLE_POPUP_DISPLAY_DURATION"] = "HTML.Application.EnablePopupDisplayDuration";
  GlobalSettingsKeys["POPUP_DISPLAY_DURATION"] = "HTML.Application.PopupDisplayDuration";
  GlobalSettingsKeys["INVERT_APP_COLORS"] = "HTML.Application.InvertColors";
  GlobalSettingsKeys["ENABLE_KEYBOARD_TOOLTIPS"] = "HTML.Application.EnableKeyboardToolTips";
  GlobalSettingsKeys["KEYBOARD_TOOLTIP_LOCATION"] = "HTML.Application.KeyboardToolTipLocation";
  GlobalSettingsKeys["FOCUS_OVERRIDE"] = "HTML.Application.FocusOverride";
  GlobalSettingsKeys["FOCUS_COLOR"] = "HTML.Application.FocusColor";
  GlobalSettingsKeys["FOCUS_THICKNESS"] = "HTML.Application.FocusThickness";
  GlobalSettingsKeys["FOCUS_OPACITY"] = "HTML.Application.FocusAlpha";
  GlobalSettingsKeys["KEYBOARD_SHORTCUTS"] = "HTML.KeyboardShortcuts";
  GlobalSettingsKeys["Avatar"] = "Avatar";
  GlobalSettingsKeys["CONTENT_SELECTOR_COLUMN_ORDER"] = "NOVA.ContentSelectorColumnOrder";
  GlobalSettingsKeys["FOCUS_TRUNCATED_HEADINGS"] = "NOVA.FocusTruncatedHeadings";
  GlobalSettingsKeys["STARTUP_SCREEN_ACTION"] = "sas.drive.logon.action";
  GlobalSettingsKeys["STARTUP_SCREEN_LAST_APP_DIRECTIVE"] = "sas.drive.logon.lastAppDirective";
  GlobalSettingsKeys["STARTUP_SCREEN_SPECIFIC_APP_DIRECTIVE"] = "sas.drive.logon.specificAppDirective";
  return GlobalSettingsKeys;
}({});
export const UI5_NO_COLOR_VALUE = 'NO_COLOR_VALUE';
export let STARTUP_SCREEN_ACTION_VALUES = /*#__PURE__*/function (STARTUP_SCREEN_ACTION_VALUES) {
  STARTUP_SCREEN_ACTION_VALUES["LAST_APP_DIRECTIVE"] = "lastAppDirective";
  STARTUP_SCREEN_ACTION_VALUES["SPECIFIC_APP_DIRECTIVE"] = "specificAppDirective";
  return STARTUP_SCREEN_ACTION_VALUES;
}({});
//# sourceMappingURL=GlobalSettingsKeys.js.map